import riderMessages from 'core/data-model/constants/validation-messages'

export const checkFactorOfSumAssuredRule = (rule, eligibilities) => {
  let errorMessage = ''

  if (
    eligibilities.basicSumAssured > 0 &&
    eligibilities.rider.sumAssured > eligibilities.basicSumAssured * rule.factor
  ) {
    errorMessage = riderMessages.RULE_MESSAGE_NOT_FOUND
  }
  return {
    type: rule.validationType,
    message: errorMessage,
  }
}
